<template>
    <div v-if="visible" class="popup-overlay" @click.self="close">
        <div class="popup-content">
            <div v-html="info_page.title" width="100%" height="600px" style="border: none"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['visible', 'info_page'],
    data() {
        return {
            showPopup: false,
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>
<style scoped>
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}
.popup-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 850px;
    width: 90%;
    max-height: 90%;
    overflow: auto;
}
</style>
